import axios, {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
  Method,
} from "axios";
// import Agent from 'agentkeepalive';

class Exception extends Error {
  constructor(error) {
    super(error.httpInfo);

    this.status = error.status;
    this.type = error.type;
    this.error = error.error;
    this.httpInfo = error.httpInfo;
  }
}

const excludedUrl = [
  "/api/cemetapub/usermanager/v1/account/login",
  /\/api\/cemetapub\/message\/v1\/phone\/\w+\/code/,
];

const HTTP = new (class Http {
  constructor() {
    this._init();
  }

  _init() {
    axios.defaults.timeout = 10000;
    // axios.defaults.httpAgent = new Agent({
    //     keepAlive: true,
    //     timeout: 60000, // active socket keepalive for 60 seconds
    //     freeSocketTimeout: 30000, // free socket keepalive for 30 seconds
    //     freeSocketKeepAliveTimeout: 10,
    //     socketActiveTTL: 100
    // });

    // 请求拦截器
    axios.interceptors.request.use(
      this._beforeSendToServer,
      this._beforeSendToServerButError
    );

    // 响应拦截器
    axios.interceptors.response.use(
      this._receiveSuccessResponse,
      this._receiveResponseNotSuccess
    );
  }

  _beforeSendToServer(config) {
    // const zh = config.url?.match(/[\u4e00-\u9fa5]/g);

    // if (zh) {
    //     const _obj = {};

    //     for (let i = 0; i < zh.length; i++) {
    //         if (!_obj[zh[i]]) {
    //             _obj[zh[i]] = encodeURIComponent(zh[i]);
    //         }
    //     }

    //     for (const key in _obj) {
    //         config.url = config.url?.replace(new RegExp(key, 'g'), _obj[key]);
    //     }
    // }

    let userId;
    let token;
    if (excludedUrl.every((url) => !config.url.match(url))) {
      userId = window.localStorage.getItem("userId");
      token = window.localStorage.getItem("token");
      if ((!token || !userId) && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    if (typeof config.headers === "undefined") {
      config.headers = {
        "x-app": 1168433,
        "x-user": userId,
        "x-auth": token,
        "x-company": "",
      };
    } else {
      config.headers["x-app"] = 1168433;
      config.headers["x-user"] = userId;
      config.headers["x-auth"] = token;
      config.headers["x-company"] = "";
    }

    return config;
  }

  async _beforeSendToServerButError(error) {
    return Promise.reject(
      new Exception({
        httpInfo: `${error}`,
        status: 0,
        error: {
          info: "request send error: not send.",
        },
      })
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async _receiveSuccessResponse(response) {
    // 这里只处理 response.status >= 200 && response.status <= 207 的情况
    const {
      data /*, config, headers, request, status, statusText*/,
    } = response;

    return Promise.resolve(data);
  }

  async _receiveResponseNotSuccess(error) {
    // const { message, name, description, number, fileName, lineNumber, columnNumber, stack, code } = error.toJSON();
    const { response, config } = error;
    // const { url, baseURL, method } = config;

    let errorResult = {
      status: 500,
      httpInfo: ` 访问 ${config.url} 失败`,
      error: { info: "" },
    };

    if (response) {
      const { data } = response;

      errorResult.status = data.status;
      errorResult.error = data;
    }

    return Promise.reject(new Exception(errorResult));
  }

  async send(url, method, options) {
    return await axios.request({
      url,
      method,
      // baseURL: ['development', undefined].includes(process?.env?.NODE_ENV) ? undefined : 'https://xxx.xxx.cxx',
      headers: options.headers,
      params: options.params,
      data: options.data,
    });
  }

  async post(url, options) {
    return await this.send(url, "post", {
      params: options.params,
      headers: options.headers,
      data: options.data,
    });
  }

  async delete(url, options) {
    return await this.send(url, "delete", {
      params: options.params,
      headers: options.headers,
      data: options.data,
    });
  }

  async put(url, options) {
    return await this.send(url, "put", {
      params: options.params,
      headers: options.headers,
      data: options.data,
    });
  }

  async get(url, options) {
    return await this.send(url, "get", {
      params: options.params,
      headers: options.headers,
      data: options.data,
    });
  }
})();

class Base {
  errorHandle(error) {
    return Promise.resolve({ error: error.error });
  }

  successHandle(data) {
    return Promise.resolve({ data });
  }
}

class System extends Base {
  constructor() {
    super();
  }

  async CheckApp() {
    return HTTP.get("/api/cemetapub/application/v1/app", {});
  }
}
class Product extends Base {
  constructor() {
    super();
  }

  async saveProduct(body) {
    return HTTP.post("/api/cemeta/aimanager/v1/article/generateparams", {
      data: body,
    })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async getProductList(params) {
    return HTTP.get("/api/cemeta/aimanager/v1/article/generateparams", {
      params,
    })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async deleteProduct(id = "") {
    return HTTP.delete("/api/cemeta/aimanager/v1/article/generateparams", {
      data: { id },
    })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }
}

class Chat extends Base {
  constructor() {
    super();
  }

  async askForAI(data) {
    return HTTP.post("/api/cemeta/aimanager/v1/article/ask", { data })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async getAnswerForAsk(msgId = "") {
    return HTTP.get(`/api/cemeta/aimanager/v1/article/${msgId}/answer`, {})
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async setArticleStar(data = { article: "", star: 0, title: "", type: "" }) {
    return HTTP.post("/api/cemeta/aimanager/v1/article/score", { data })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async changeForCount(data) {
    return HTTP.post("/api/cemeta/balancemanager/v1/ticket/exchange", { data })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async saveCount(data) {
    return HTTP.post("/api/cemeta/aimanager/v1/article/consumption", { data })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async getTicket(params) {
    return HTTP.get("/api/cemetapub/balancemanager/v1/ticket/potential", {
      params,
    })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }
}

class Account extends Base {
  constructor() {
    super();
  }

  // async getUserInfo(data) {
  //   return HTTP.post("/api/cemetamgr/usermanager/v1/account/user", {
  //     data,
  //   })
  //     .then((r) => this.successHandle(r))
  //     .catch((e) => this.errorHandle(e));
  // }

  async getWordsCount() {
    return HTTP.get("/api/cemeta/balancemanager/v1/balance", {})
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async getCode(phone) {
    return HTTP.get(`/api/cemetapub/message/v1/phone/${phone}/code`, {
      params: { type: "login-phone-code" },
    })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }

  async login(data) {
    return HTTP.post("/api/cemetapub/usermanager/v1/account/login", { data })
      .then((r) => this.successHandle(r))
      .catch((e) => this.errorHandle(e));
  }
}

export default {
  System: new System(),
  Chat: new Chat(),
  Account: new Account(),
  Product: new Product(),
};



// WEBPACK FOOTER //
// ./src/http/api.js